const updatePagination = (swiper, paginationEl, slidesCount = null) => {
	if (!swiper || !paginationEl) return;

	let totalSlides = 0;
	let currentSlide = swiper.realIndex + 1

	if(slidesCount) {
		totalSlides = slidesCount;
	} else {
		totalSlides = swiper.params.loop ? swiper.slides.length - 2 : swiper.slides.length
	}

	paginationEl.querySelectorAll('span')[0].innerHTML = currentSlide
	paginationEl.querySelectorAll('span')[1].innerHTML = totalSlides
};

export { updatePagination }
